import Link from 'next/link'

type Breadcrumb = {
  label: string
  href: string
}
interface BreadcrumbType {
  breadcrumbs: Breadcrumb[]
  className?: string
  homeText?: string
}

const PageBreadcrumb = ({
  breadcrumbs,
  homeText = 'Trang chủ',
  className = 'mb-[49px]',
}: BreadcrumbType) => {
  return (
    <div className={`breadCrumb ${className}`}>
      <ul className='flex !list-none items-center gap-1 text-base text-blue'>
        <li key='breadcumb-10000'>
          <Link href='/' className='home block text-blue'>
            {homeText}
          </Link>
        </li>
        <li className='divider'>{'>'}</li>
        {breadcrumbs.map((e: Breadcrumb, index: number) => (
          <li className='divider' key={`breadcumb-${e.label}`}>
            <Link href={e.href} className='home block text-blue'>
              {e.label}
            </Link>
            {index > 0 && <span className='divider'>{'>'}</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}
export default PageBreadcrumb
